// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VIvE","clinicsSelect":"styles_clinicsSelect__1Vvux"};